import { Link } from '@inertiajs/react';

/* =============================================
   Animated Farm Scene (vertical for left panel)
============================================= */
function FarmScene() {
    return (
        <svg viewBox="0 0 500 600" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-md">
            {/* Birds */}
            <g className="a-bird" opacity="0.25">
                <path d="M80 80 Q85 74 90 80 Q95 74 100 80" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
            </g>
            <g className="a-bird-d" opacity="0.2">
                <path d="M180 55 Q184 50 188 55 Q192 50 196 55" stroke="white" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
            </g>
            <g className="a-bird" style={{animationDelay:'4s'}} opacity="0.15">
                <path d="M350 90 Q354 85 358 90 Q362 85 366 90" stroke="white" strokeWidth="1" fill="none" strokeLinecap="round"/>
            </g>

            {/* Sun */}
            <g className="a-float-s">
                <circle cx="400" cy="90" r="50" fill="white" opacity="0.08"/>
                <circle cx="400" cy="90" r="32" fill="white" opacity="0.1"/>
                <circle cx="400" cy="90" r="16" fill="#fef08a" opacity="0.25"/>
            </g>
            <g className="a-spin" style={{transformOrigin:'400px 90px'}} opacity="0.08">
                <line x1="400" y1="45" x2="400" y2="32" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <line x1="432" y1="58" x2="441" y2="49" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <line x1="445" y1="90" x2="458" y2="90" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <line x1="432" y1="122" x2="441" y2="131" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <line x1="400" y1="135" x2="400" y2="148" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <line x1="368" y1="122" x2="359" y2="131" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <line x1="355" y1="90" x2="342" y2="90" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <line x1="368" y1="58" x2="359" y2="49" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </g>

            {/* Clouds */}
            <g className="a-drift" opacity="0.1">
                <ellipse cx="120" cy="110" rx="55" ry="16" fill="white"/>
                <ellipse cx="145" cy="100" rx="38" ry="13" fill="white"/>
                <ellipse cx="100" cy="105" rx="30" ry="11" fill="white"/>
            </g>
            <g className="a-drift" style={{animationDelay:'3s'}} opacity="0.07">
                <ellipse cx="340" cy="140" rx="42" ry="13" fill="white"/>
                <ellipse cx="360" cy="133" rx="30" ry="11" fill="white"/>
            </g>

            {/* Ground */}
            <ellipse cx="250" cy="520" rx="260" ry="35" fill="white" opacity="0.06"/>
            <ellipse cx="250" cy="530" rx="200" ry="20" fill="white" opacity="0.04"/>

            {/* Far left plant */}
            <g className="a-sway" style={{animationDelay:'0.5s'}} opacity="0.5">
                <line x1="65" y1="520" x2="65" y2="460" stroke="#86efac" strokeWidth="2" strokeLinecap="round"/>
                <path d="M65 480 C52 470 36 467 32 476 C29 483 37 490 52 486Z" fill="#86efac" opacity="0.6"/>
                <path d="M65 495 C76 486 88 483 92 490 C95 496 86 502 74 498Z" fill="#4ade80" opacity="0.5"/>
            </g>

            {/* Left plant */}
            <g className="a-sway" style={{animationDelay:'0.3s'}} opacity="0.6">
                <line x1="140" y1="520" x2="140" y2="430" stroke="#86efac" strokeWidth="2.5" strokeLinecap="round"/>
                <path d="M140 460 C122 445 95 440 86 452 C80 462 90 474 112 469 C128 465 140 460 140 460Z" fill="white" opacity="0.15"/>
                <path d="M140 480 C158 468 178 464 185 474 C190 482 178 490 162 486Z" fill="white" opacity="0.1"/>
                <path d="M140 445 C130 432 118 428 113 435 C110 442 118 449 132 445Z" fill="#86efac" opacity="0.4"/>
            </g>

            {/* CENTER MAIN PLANT */}
            <g className="a-grow">
                <path d="M250 528 C250 490 248 420 250 330" stroke="white" strokeWidth="4" strokeLinecap="round" fill="none" opacity="0.3"/>
                <path d="M250 520 C249 490 249 450 250 400" stroke="white" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.15"/>
            </g>

            {/* Main left leaf */}
            <g className="a-sway">
                <path d="M250 410 C220 390 178 378 150 395 C132 407 142 432 170 434 C198 436 238 422 250 410Z" fill="white" opacity="0.15"/>
                <path d="M250 410 C220 398 185 390 158 400" stroke="white" strokeWidth="1.2" fill="none" opacity="0.1"/>
            </g>

            {/* Main right leaf */}
            <g className="a-sway-r">
                <path d="M250 375 C280 354 322 342 355 358 C372 368 364 396 338 398 C312 400 266 388 250 375Z" fill="white" opacity="0.12"/>
                <path d="M250 375 C285 360 320 352 345 362" stroke="white" strokeWidth="1.2" fill="none" opacity="0.08"/>
            </g>

            {/* Upper small leaves */}
            <g className="a-sway" style={{animationDelay:'0.6s'}}>
                <path d="M248 360 C228 346 205 338 193 348 C186 358 197 370 215 368 C230 366 245 363 248 360Z" fill="white" opacity="0.1"/>
            </g>
            <g className="a-sway-r" style={{animationDelay:'0.9s'}}>
                <path d="M252 342 C268 328 290 322 300 332 C305 342 295 352 280 350Z" fill="white" opacity="0.08"/>
            </g>

            {/* Sprout top */}
            <g className="a-float">
                <path d="M250 330 C250 318 245 298 240 282 C235 268 245 258 250 263 C255 258 265 268 260 282 C255 298 250 318 250 330Z" fill="white" opacity="0.2"/>
                <ellipse cx="250" cy="260" rx="6" ry="4" fill="white" opacity="0.15"/>
            </g>

            {/* Right plant */}
            <g className="a-sway-r" style={{animationDelay:'0.8s'}} opacity="0.55">
                <line x1="370" y1="520" x2="370" y2="445" stroke="#86efac" strokeWidth="2.5" strokeLinecap="round"/>
                <path d="M370 470 C388 455 412 452 418 462 C422 470 410 480 392 476Z" fill="white" opacity="0.12"/>
                <path d="M370 490 C355 478 336 475 332 484 C328 492 340 500 358 495Z" fill="white" opacity="0.1"/>
            </g>

            {/* Far right plant */}
            <g className="a-sway" style={{animationDelay:'1.2s'}} opacity="0.4">
                <line x1="440" y1="520" x2="440" y2="475" stroke="#86efac" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M440 490 C452 480 466 478 470 486 C472 492 462 498 450 494Z" fill="white" opacity="0.1"/>
                <path d="M440 500 C430 490 416 488 413 495 C410 502 420 506 434 502Z" fill="white" opacity="0.08"/>
            </g>

            {/* Water drops */}
            <g className="a-float-d" opacity="0.3">
                <path d="M190 428 C190 423 187 416 183 411 C179 416 176 423 176 428 C176 433 183 437 190 428Z" fill="#67e8f9"/>
            </g>
            <g className="a-float" opacity="0.25">
                <path d="M320 392 C320 387 317 380 313 375 C309 380 306 387 306 392 C306 397 313 401 320 392Z" fill="#67e8f9"/>
            </g>

            {/* Floating particles */}
            <g opacity="0.2">
                <circle cx="40" cy="200" r="3" fill="white" className="a-float"/>
                <circle cx="100" cy="160" r="2.5" fill="white" className="a-float-d"/>
                <circle cx="200" cy="180" r="2" fill="white" className="a-float"/>
                <circle cx="300" cy="170" r="3" fill="white" className="a-float-d"/>
                <circle cx="420" cy="200" r="2.5" fill="white" className="a-float"/>
                <circle cx="460" cy="250" r="2" fill="white" className="a-float-d"/>
                <circle cx="80" cy="300" r="2" fill="white" className="a-float"/>
                <circle cx="380" cy="280" r="2.5" fill="white" className="a-float-d"/>
            </g>

            {/* Ground line / fence */}
            <g opacity="0.08">
                <line x1="20" y1="518" x2="480" y2="518" stroke="white" strokeWidth="1"/>
                <line x1="80" y1="505" x2="80" y2="520" stroke="white" strokeWidth="1"/>
                <line x1="170" y1="505" x2="170" y2="520" stroke="white" strokeWidth="1"/>
                <line x1="330" y1="505" x2="330" y2="520" stroke="white" strokeWidth="1"/>
                <line x1="420" y1="505" x2="420" y2="520" stroke="white" strokeWidth="1"/>
            </g>
        </svg>
    );
}

/* =============================================
   GuestLayout — Split-screen design
============================================= */
export default function GuestLayout({ children }) {
    return (
        <div className="min-h-screen flex flex-col lg:flex-row">
            {/* ===== LEFT PANEL — Branding ===== */}
            <div className="hidden lg:flex lg:w-[55%] xl:w-[52%] relative bg-emerald-800 flex-col items-center justify-center overflow-hidden">
                {/* Background layers */}
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-900 via-emerald-800 to-emerald-700" />
                <div className="absolute inset-0 opacity-[0.03]" style={{backgroundImage:'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize:'24px 24px'}} />

                {/* Decorative blobs */}
                <div className="absolute top-0 right-0 w-96 h-96 bg-emerald-600/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 a-pulse" />
                <div className="absolute bottom-0 left-0 w-80 h-80 bg-emerald-500/15 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3 a-pulse-d" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-emerald-400/5 rounded-full blur-3xl" />

                {/* Content */}
                <div className="relative z-10 flex flex-col items-center px-12 text-center max-w-lg">
                    {/* Logo */}
                    <div className="mb-8">
                        <div className="w-16 h-16 bg-white rounded-2xl shadow-xl shadow-emerald-900/40 flex items-center justify-center mx-auto mb-5">
                            <span className="text-emerald-800 font-black text-2xl tracking-tighter">PH</span>
                        </div>
                        <h1 className="text-3xl font-extrabold text-white tracking-tight leading-tight">Pheladelfia</h1>
                        <p className="text-emerald-300/70 text-sm font-semibold tracking-[0.2em] uppercase mt-1">Agricultural LLC</p>
                    </div>

                    {/* Illustration */}
                    <div className="w-full max-w-sm mb-8">
                        <FarmScene />
                    </div>

                    {/* Tagline */}
                    <p className="text-emerald-200/50 text-sm font-medium tracking-wide">Growing Together, Harvesting Success</p>

                    {/* Stats strip */}
                    <div className="flex items-center gap-8 mt-8 pt-8 border-t border-emerald-700/40">
                        <div className="text-center">
                            <p className="text-2xl font-extrabold text-white">24/7</p>
                            <p className="text-[10px] text-emerald-300/50 font-semibold uppercase tracking-wider mt-0.5">Operations</p>
                        </div>
                        <div className="w-px h-8 bg-emerald-700/40" />
                        <div className="text-center">
                            <p className="text-2xl font-extrabold text-white">100%</p>
                            <p className="text-[10px] text-emerald-300/50 font-semibold uppercase tracking-wider mt-0.5">Secure</p>
                        </div>
                        <div className="w-px h-8 bg-emerald-700/40" />
                        <div className="text-center">
                            <p className="text-2xl font-extrabold text-white">UAE</p>
                            <p className="text-[10px] text-emerald-300/50 font-semibold uppercase tracking-wider mt-0.5">Based</p>
                        </div>
                    </div>
                </div>

                {/* Bottom accent */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-emerald-400 via-green-300 to-emerald-400 opacity-40" />
            </div>

            {/* ===== RIGHT PANEL — Form ===== */}
            <div className="flex-1 flex flex-col min-h-screen lg:min-h-0">
                {/* Mobile header */}
                <div className="lg:hidden bg-emerald-800 px-5 py-4">
                    <div className="flex items-center gap-3">
                        <div className="w-9 h-9 bg-white rounded-lg shadow-sm flex items-center justify-center">
                            <span className="text-emerald-800 font-extrabold text-sm tracking-tighter">PH</span>
                        </div>
                        <div>
                            <p className="text-sm font-bold text-white leading-none">Pheladelfia</p>
                            <p className="text-[10px] text-emerald-300/60 mt-0.5">Agricultural LLC</p>
                        </div>
                    </div>
                </div>

                {/* Form area */}
                <div className="flex-1 flex items-center justify-center px-5 py-10 sm:px-8 bg-white">
                    <div className="w-full max-w-sm">
                        {/* Card */}
                        <div className="bg-white rounded-2xl border border-slate-200/80 shadow-xl shadow-slate-200/50 p-7 sm:p-8">
                            {children}
                        </div>

                        {/* Footer */}
                        <div className="mt-6 text-center">
                            <p className="text-[11px] text-slate-400">&copy; {new Date().getFullYear()} Pheladelfia Agricultural LLC. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
